import type { AdminInitialStateQuery } from "@/api/graphql"
import type { SkyltmaxViteContext } from "@/common/vite_context"
import React from "react"

export const CurrentAdminContext = React.createContext<AdminInitialStateQuery["currentAdminSession"]>({
  id: "0",
  name: "placeholder",
  developer: false,
  legacyRoles: [],
  __typename: "Admin",
})

export const useCurrentAdminContext = () => React.useContext(CurrentAdminContext)

interface EpicViteCustomContextType {
  context: Partial<SkyltmaxViteContext>
  setContext: (context: Partial<SkyltmaxViteContext>) => void
}

export const EpicViteCustomContext = React.createContext<EpicViteCustomContextType>({
  context: {},
  setContext: () => {},
})

export const useEpicViteCustomContext = () => React.useContext(EpicViteCustomContext)
